import { Alpine } from "alpinejs";

const giftData = document.getElementById('gift-data');

export default () => ({
  // Configuration from DOM
  product: JSON.parse(giftData?.innerHTML ?? "{}"),
  threshold: Number(giftData?.getAttribute("data-gift-threshold")),
  
  // State variables
  isEligible: false,
  cartTotal: Alpine.store('cart')?.subtotalPrice || 0,
  giftAdded: false, // Added missing property
  giftLineItemKey: null, // Added missing property
  isProcessing: false,
  
  // Debug mode
  debug: true,

  init() {
    this.log('Initializing GWP component');
    this.log('GWP product data:', this.product);
    this.log('Initial cart total:', this.cartTotal);
    this.log('GWP threshold:', this.threshold);
    this.log('Initial eligibility:', this.isEligible);
  },
  
  log(message, data = null) {
    if (this.debug) {
      const timestamp = new Date().toISOString();
      const prefix = `[GWP ${timestamp}]`;
      
      if (data !== null) {
        console.log(`${prefix} ${message}`, data);
      } else {
        console.log(`${prefix} ${message}`);
      }
    }
  },

})